import {Skeleton} from '@mantine/core';
import type {FC} from 'react';
import type {z} from 'zod';
import type {IndustryCategorySchema} from '../../../../core/entities/reports/schema';
import {cn} from '../../../../lib/classname';
import {CommonLink} from '../../../../shared/components/CommonLink';

type IndustryCategory = z.infer<typeof IndustryCategorySchema>;
type Props = {
  categories?: IndustryCategory[];
};

export const IndustrySelector: FC<Props> = ({categories}) => {
  return (
    <div className="h-68 bg-white flex justify-around gap-8 overflow-x-scroll pc:w-[1200px] pc:mt-16 pc:rounded-[20px] pc:shadow-card pc:px-16 pc:py-8">
      {categories ? (
        categories.map((industry) => (
          <CommonLink
            key={industry.id}
            className={cn(
              'text-base text-primary font-bold border-2 border-primary rounded-[20px] px-8 py-4 pc:px-16 pc:py-8 text-nowrap hover:cursor-pointer',
            )}
            href={`/reports/industry/${industry.id}`}
          >
            {industry.name}
          </CommonLink>
        ))
      ) : (
        <Skeleton height={40} />
      )}
    </div>
  );
};
